import firebase from "firebase/app";
import "firebase/firestore";

export default {
  loadPharmacies: function() {
    const pharmacyDocuments = firebase.firestore().collection("pharmacy");
    return new Promise(resolve => {
      pharmacyDocuments.get().then(pharmacyList => {
        resolve(
          pharmacyList.docs.map(pharmacy => {
            var data = pharmacy.data();
            data.id = pharmacy.id;
            return data;
          })
        );
      });
    });
  },

  updatePharmacy: function(pharmacy) {
    const pharmacyDocuments = firebase.firestore().collection("pharmacy");
    return new Promise(resolve => {
      let id = pharmacy.id;
      var pharmacyClone = {};
      Object.assign(pharmacyClone, pharmacy);
      delete pharmacyClone.id;
      pharmacyDocuments
        .doc(id)
        .update(pharmacyClone)
        .then(resolve());
    });
  },

  deletePharmacy: function(id) {
    const pharmacyDocuments = firebase.firestore().collection("pharmacy");
    return new Promise(resolve => {
      pharmacyDocuments
        .doc(id)
        .delete()
        .then(resolve());
    });
  },

  getUserActivationRequest(uid) {
    const docs = firebase.firestore().collection("pharmacy-activation-requst");
    return new Promise(resolve => {
      docs
        .doc(uid)
        .get()
        .then(r => resolve(r.data()));
    });
  },

  setUserPharmacy(uid, email, pharmacy_place_id, pharmacy_title) {
    const collection = firebase
      .firestore()
      .collection("pharmacy-activation-requst");
    return new Promise(resolve => {
      const request = {
        email: email,
        pharmacy: {
          id: pharmacy_place_id,
          title: pharmacy_title
        }
      };
      collection
        .doc(uid)
        .set(request, { merge: true })
        .then(resolve());
    });
  }
};
